module.exports = __webpack_public_path__ + "videos/mts-products-chats-appointment-moderators.5b612fd.mp4";